import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'rateResultSurvey',
  'feedbackNewFormReceived',
  'feedbackLipsyncNewFormReceived',
  'rateLipSyncStart',
  'rateLipSyncDone',
  'ttsFirstProjectFeedbackRequested',
  'ttsFirstProjectRatingReceived',
  'feedbackNewFormClosed',
  'feedbackLipsyncNewFormClosed',
  'ttsFirstProjectFeedbackClosed',
  'ttsFirstProjectFeedbackReceived',
] as const;

export const feedbackEvents = getMappedEvents([...EVENTS], {
  shouldSendRaskTTSData: true,
  shouldSendSubscriptionData: true,
});
